import React from "react";
import { useController, useFormContext } from "react-hook-form";
import { Group, Stack, Text, Button, ActionIcon, FileButton, Tooltip } from "@mantine/core";

import base_url from "../../api/bootapi";
import attachmenturl from "../../api/attachmenturl";
import {ReactComponent as UploadIcon} from "../../assets/humbleicons_upload.svg"



const RHFFileUpload = ({
  name,
  label,
  rules,
  accept = '.pdf,.jpg,.jpeg,.png,.heic,.heif,.webp',
  withAsterisk = false,
  withDeleteButton = true,
  withUploadButton = true,
  multiple = false,
  onViewFile, // Optional custom handler if you need to open URLs from a server
}) => {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control, rules });

  const handleClear = () => {
    onChange(null);
  };

 const handleView = () => {
  if (!hasFile) return;

  if (onViewFile) {
    onViewFile(value);
    return;
  }

  if (multiple) {
    value.forEach((file) => {
      if (file instanceof File) {
        window.open(URL.createObjectURL(file), "_blank");
      }
    });
    return;
  }

  if (value instanceof File) {
    window.open(URL.createObjectURL(value), "_blank");
  } else {
    window.open(attachmenturl + value, "_blank");
  }
};

 const hasFile = multiple
  ? Array.isArray(value) && value.length > 0
  : !!value;

const buttonText = (() => {
  if (!hasFile) return "Upload File";

  if (multiple) {
    return `${value.length} File${value.length > 1 ? "s" : ""}`;
  }

  return value instanceof File ? value.name : "View File";
})();

  return (
    <Stack gap={4}>
      {label && (
        <Text fw={400} size="16px" mb={'12px'} c="#222">
          {label}{withAsterisk && <span style={{color:"red"}}> *</span>}
        </Text>
      )}

      <Group gap="0" styles={{
        root: {
          backgroundColor: '#e8eef7',
          borderRadius:'999px',
      }}}>
        {/* VIEW BUTTON */}
        <Button
          variant="light"
          color={hasFile ? "#495057" : "#7b8287"}
          
         
          disabled={!hasFile}
          onClick={handleView}
          styles={{
            root: {
              padding: '10px 24px',
              boxSizing: 'content-box',
              background: 'transparent',
             
              
              // border: `1px solid var(--mantine-color-${hasFile?'indigo':'gray'}-4)`,
              // backgroundColor:hasFile?"var(--mantine-color-indigo-0)":"var(--mantine-color-white-0)" ,
              // color: "#495057",
              flex: 1, // Makes it stretch like your screenshot
              // maxWidth: "200px"
            },
            inner: {
              justifyContent:'flex-start'
            }
          }}
        >
         {buttonText}
        </Button>

        {/* DELETE BUTTON */}
        {withDeleteButton && <Tooltip label="Remove File" withArrow position="top">
          <ActionIcon
            variant="light"
            color="red"
            size="lg" // Adjust size to match the button height (usually 36px)
            disabled={!hasFile}
            onClick={handleClear}
            style={{
              width: 60,
              height: '100%',
              border: "1px solid var(--mantine-color-red-3)",
              backgroundColor: "var(--mantine-color-red-0)",
            }}
          >
            {/* <Trash2 size={18} strokeWidth={1.5} /> */}
          </ActionIcon>
        </Tooltip>}
        

        {/* UPLOAD BUTTON (Wraps ActionIcon in Mantine's FileButton) */}
        {
          withUploadButton && <FileButton onChange={onChange} accept={accept} multiple={multiple}>
          {(props) => (
            <Tooltip label="Upload File" withArrow position="top">
              <ActionIcon
                {...props}
                variant="default"
                size="lg"
                style={{
                  width: 80,
              height: '100%',
                  background: 'transparent',
                 border:'none'
                }}
              >
                <UploadIcon size={18} strokeWidth={1.5} color="#495057" />
              </ActionIcon>
            </Tooltip>
          )}
        </FileButton>
        }
        
      </Group>

      {/* RHF Error Message */}
      {error && (
        <Text c="red" size="xs" mt={4}>
          {error.message}
        </Text>
      )}
    </Stack>
  );
};

export default RHFFileUpload;